import {LabelRegular, TextMedium} from '@hm/fundamental'
import React from 'react'

import {useTranslation} from '../../hooks/useTranslation'

type RoleCommentCategoryLookupChipProps = {
  commentCategory: string
  error?: Error
}

export const RoleCommentCategoryLookupChip = ({
  commentCategory
}: RoleCommentCategoryLookupChipProps) => {
  const {t} = useTranslation()

  return (
    <div className="flex flex-col items-start">
      <LabelRegular className="text-foreground_faded">
        {t('manageUser.commentCategory')}
      </LabelRegular>
      <TextMedium className="text-foreground">{commentCategory}</TextMedium>
    </div>
  )
}
